import React from 'react'
import { Motion, spring, presets } from 'react-motion'

const { stiff } = presets

import './Albumart.css'

function Albumart ({ freq, imageUrl }) {
  return (
    <Motion
      defaultStyle={{
        rX: 0,
        gX: 0,
        bX: 0
      }}
      style={{
        rX: spring(freq[0], stiff),
        gX: spring(freq[1], stiff),
        bX: spring(freq[2], stiff)
      }}
    >
      {value => (
        <div className="Albumart">
          <div
            className="Albumart__red"
            style={{
              transform: `translateX(${value.rX}px)`,
              backgroundImage: `url(${imageUrl})`
            }}
          />
          <div
            className="Albumart__green"
            style={{
              transform: `translateX(${-1 * value.gX}px)`,
              backgroundImage: `url(${imageUrl})`
            }}
          />
          <div
            className="Albumart__blue"
            style={{
              transform: `translateX(${value.bX}px)`,
              backgroundImage: `url(${imageUrl})`
            }}
          />
        </div>
      )}
    </Motion>
  )
}

export default Albumart



/** WEBPACK FOOTER **
 ** ./src/Albumart/Albumart.js
 **/